module.exports = __webpack_public_path__ + "img/logo_regionbretagne.10973e5f.jpg";